import React from 'react'
import { FadeIn } from 'lib/ui/components'
import { useCustomer } from 'lib/core/hooks/useCustomer'
import { useStoreView } from 'hooks/useStoreView'
import { Contact } from './components/Contact'
import { OrderHistory } from './components/OrderHistory'
import { DefaultAddress } from './components/DefaultAddress'
import { Container, FirstColumn, SecondColumn } from './components/Styled'
import { Subscriptions } from './components/Subscriptions'
import { DefaultPayment } from './components/DefaultPayment'
import { ShareStory } from './components/ShareStory'

export const Home = () => {
  const { customer } = useCustomer()
  const { isSofiaAndGrace } = useStoreView()
  const defaultShippingAddress = customer?.addresses.find(address => address.isDefaultShipping)
  const defaultBillingAddress = customer?.addresses.find(address => address.isDefaultBilling)

  return (
    <div>
      <FadeIn>
        <Container>
          <FirstColumn>
            <Subscriptions />
            <OrderHistory />
          </FirstColumn>
          <SecondColumn>
            <Contact customer={customer} />
            {defaultShippingAddress && (
              <DefaultAddress
                address={defaultShippingAddress}
                label='customer.account.dashboard.title.defaultShipping'
              />
            )}
            {defaultBillingAddress && (
              <DefaultPayment
                address={defaultBillingAddress}
                paymentMethod=''
                label='customer.account.dashboard.title.defaultBilling'
              />
            )}
            {isSofiaAndGrace && (
              <ShareStory />
            )}
          </SecondColumn>
        </Container>
      </FadeIn>
    </div>
  )
}
